import React from 'react';
interface AnimatedWaveDividerProps {
  topColor?: string;
  bottomColor?: string;
  waveColor?: string;
  flip?: boolean;
}
export function AnimatedWaveDivider({
  topColor = '#f5f1ed',
  bottomColor = '#ffffff',
  waveColor = '##2d4a3a',
  flip = false
}: AnimatedWaveDividerProps) {
  // When flipped, swap the colors so the wave properly transitions
  const containerBg = flip ? bottomColor : topColor;
  const waveFill = flip ? topColor : bottomColor;
  return <div className="relative w-full overflow-hidden" style={{
    backgroundColor: containerBg
  }} data-id="element-2">
      

      <style data-id="element-3">{`
        @keyframes wave {
          0%, 100% {
            transform: translateX(0) scaleY(1);
          }
          50% {
            transform: translateX(-25px) scaleY(1.05);
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          svg path {
            animation: none !important;
          }
        }
      `}</style>
    </div>;
}